<div class="row">
  <div class="col-12 col-md-8">
    <nb-card accent="primary" size="tiny">
      <nb-card-header class="d-flex">
        <span class="mr-auto">{{'create_tag_group' | translate }}</span>
        <nb-icon icon="question-mark-circle-outline" [nbPopover]="helpTagCreation" nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"></nb-icon>
      </nb-card-header>

      <nb-card-body class="d-flex align-items-center">
        <nb-actions size="medium">
          <nb-action class="create-action">
            <a [routerLink]="['new', {type:'tag'}]" class="text-center">
              <nb-icon icon="pricetags-outline"></nb-icon>
              <div>Tag</div>
            </a>
          </nb-action>
          <nb-action class="create-action">
            <a [routerLink]="['new', {type:'group'}]" class="text-center">
              <nb-icon icon="folder-outline"></nb-icon>
              <div>{{'group' | translate }}</div>
            </a>
          </nb-action>
        </nb-actions>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-12 col-md-4">
    <nb-card accent="primary" size="tiny">
      <nb-card-header class="d-flex">
        <span class="mr-auto">{{'information' | translate }}</span>
        <nb-icon icon="question-mark-circle-outline" [nbPopover]="helpInformation" nbPopoverTrigger="hover"
          nbPopoverPlacement="bottom"></nb-icon>
      </nb-card-header>

      <nb-card-body>
        <div>{{'contract' | translate }}: {{contract?.plan}}</div>
        <div>Tags: {{($count | async)}} / {{contract?.limits?.tags}}</div>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <nb-card accent="primary">
      <nb-card-header class="d-flex align-items-center">
        <span class="mr-auto">{{'administration_tag_group' | translate }}</span>
        <div class="w-25 pr-0 d-flex justify-content-end">
          <input nbInput #searchInput fullWidth type="text" placeholder="{{'search' | translate }}" (keyup)="updateFilter($event)" />
        </div>
      </nb-card-header>

      <nb-card-body>
        <ngx-datatable class="ngx-datatable bootstrap" headerHeight="auto" rowHeight="auto" [columnMode]="'force'"
          [rows]="data" [columns]="columns" [reorderable]="true"
          (activate)="($event.type === 'click') && $event.cellElement.blur()" [treeFromRelation]="'parentId'"
          [treeToRelation]="'id'" (treeAction)="onTreeAction($event)">
        </ngx-datatable>
      </nb-card-body>
    </nb-card>
  </div>
</div>

<!-- TableColumns Header -->
<ng-template #nameHdrTpl let-column="column">
  {{ column.prop | translate }}
</ng-template>

<!-- TableColumns -->

<ng-template #buttonsTemplate let-row="row" let-value="value" let-button="column.actions">
  <nb-icon class="action-icon" [routerLink]="row.id + '/info'" icon="info-outline" status="basic" title="{{'info' | translate}} {{row.name}}"></nb-icon>
  <nb-icon class="action-icon" [routerLink]="row.id" icon="edit-outline" title="{{'edit' | translate }} {{row.name}}"></nb-icon>
  <nb-icon class="action-icon" (click)="handleClickDelete(row)" icon="trash-2-outline" title="{{'delete' | translate }} {{row.name}}"></nb-icon>
  <nb-icon class="action-icon" (click)="handleClickAddChildTag(row)" icon="plus-circle-outline" title="{{'create_tag_or_group' | translate}} {{row.name}}"></nb-icon>
</ng-template>

<ng-template #treeToggleTemplate let-tree="cellContext" let-value="value">
  <nb-icon class="tag-icon" [class.pointer]="hasChilds(tree.row)" *ngIf="tree.row.group" (click)="tree.onTreeAction()"
    [icon]="hasChilds(tree.row)?'folder-doc':'folder-outline'" [pack]="hasChilds(tree.row)?'custom':null"
    title="{{tree.row.name}}">
  </nb-icon>
  <nb-icon class="tag-icon" [class.pointer]="hasChilds(tree.row)" *ngIf="!tree.row.group" icon="pricetags-outline"
    title="{{tree.row.name}}"></nb-icon>
</ng-template>

<ng-template #treeLabelTemplate let-row="row" let-value="value" ngx-datatable-cell-template>
  <span (click)="onTreeAction(row)" [class.pointer]="hasChilds(row)">{{ value }}</span>
</ng-template>

<!-- Modals-->

<ng-template #deleteDialog let-context let-ref="dialogRef">
  <nb-card accent="primary">
    <nb-card-header>{{'delete' | translate }}</nb-card-header>
    <nb-card-body>{{'delete_question' | translate }} {{ context.tag.name }}?</nb-card-body>
    <nb-card-footer class="d-flex">
      <button nbButton size="medium" fullWidth status="primary" class="mr-2" (click)="ref.close()">{{'close' | translate }}</button>
      <button nbButton size="medium" fullWidth status="primary" (click)="context.delete();ref.close();">{{'delete' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #editDialog let-tag let-ref="dialogRef">
  <nb-card class="dialog-card">
    <nb-card-header>{{ ((tag.id?'Update':'Create') | translate) + ' ' + (tag.group? 'Group': 'Tag')}}</nb-card-header>
    <nb-card-body>
      <div class="form-group">
        <label>{{'tag_name' | translate}}</label>
        <input type="text" nbInput fullWidth fieldSize="small" placeholder="{{'tag_name' | translate}}" [(ngModel)]="tag.name">
      </div>
      <div class="form-group">
        <nb-checkbox [(ngModel)]="tag.group" name="group">
          {{'group' | translate }}
        </nb-checkbox>
      </div>
      <div class="form-group">
        <label>{{'tag_source_id' | translate}}</label>
        <input type="text" nbInput fullWidth fieldSize="small" placeholder="Name" [(ngModel)]="tag.sourceId">
      </div>
      <div class="form-group">
        <label>{{'tag_expiry_date' | translate}}</label>
        <input nbInput fullWidth placeholder="{{'pick_date' | translate}}" [nbDatepicker]="dateTimePicker" [(ngModel)]="expiration">
        <nb-date-timepicker #dateTimePicker singleColumn format="dd.MM.yyyy HH:mm"></nb-date-timepicker>
      </div>

    </nb-card-body>
    <nb-card-footer class="d-flex">
      <button class="mr-auto" nbButton status="primary" (click)="ref.close()">{{'close' |translate}}</button>
      <button nbButton status="primary" (click)="handleClickSave(tag);ref.close();">{{'save' | translate}}</button>
    </nb-card-footer>
  </nb-card>

</ng-template>

<!-- HELP TEXT -->

<ng-template #helpTagCreation>
  <div class="primitive-overlay">
    {{'help_tag_creation' | translate}}
  </div>
</ng-template>

<ng-template #helpInformation>
  <div class="primitive-overlay" [innerHTML]="'help_tag_information' | translate">
  </div>
</ng-template>
